import instance from './axiosInstance';

export default function getCompareFilterData(query, options = {}, http = instance) {
  return http.post('/metrics', query, options);
}
